import type { ProductIconThemeManifest } from "../contracts";
import type { ProductIconSlotId } from "./icon-slot-registry";

export function createProductIconThemeRegistry(
    manifests: ProductIconThemeManifest<ProductIconSlotId>[],
): Map<string, ProductIconThemeManifest<ProductIconSlotId>> {
    return new Map(manifests.map((manifest) => [manifest.id, manifest]));
}
